import { EditRightsProvider } from '@/infrastructure/hooks/useEditRights';
import { ConfirmationDialogProvider } from './confirmationDialog';
import { UnsavedStatusContextProvider } from './unsavedStatus';
import { ProfileDesignProvider } from '@/infrastructure/hooks/useProfileDesign';
import { ProfileDesignForUnitsProvider } from '@/infrastructure/hooks/useProfileDesignForUnits';
import { HeaderActionsProvider } from '@/components/Header/useHeaderActions';
import LtNotificationsProvider from '@/infrastructure/notifications/LtNotificationsProvider';
import { VisibilityConfigProvider } from '@/infrastructure/hooks/useVisibility';
import { UDTProvider } from '@/infrastructure/hooks/useUDT';
import { ContactPersonsProvider } from '@/infrastructure/hooks/useContactPersons';

const providers = [
  [UnsavedStatusContextProvider, 'UnsavedStatusContextProvider'],
  [ConfirmationDialogProvider, 'ConfirmationDialogProvider'],
  [HeaderActionsProvider, 'HeaderActionsProvider'],
  [LtNotificationsProvider, 'LtNotificationsProvider'],
] as const;

// Each of these providers needs the domain to be verified,to avoid auth0 token call fail issue
// `domainVerified` check ensures that the use is logged in and is on correct domain before making authenticated call
const authNeededProviders = [
  [VisibilityConfigProvider, 'VisibilityConfigProvider'],
  [EditRightsProvider, 'EditRightsProvider'],
  [ProfileDesignProvider, 'ProfileDesignProvider'],
  [ProfileDesignForUnitsProvider, 'ProfileDesignForUnitsProvider'],
  [UDTProvider, 'UDTProvider'],
  [ContactPersonsProvider, 'ContactPersonsProvider'],
] as const;

export const NoAuthNeededContextProvider: React.FC = ({ children }) => {
  return providers.reduce((prev, [Provider, key]) => {
    return <Provider key={key}>{prev}</Provider>;
  }, children as JSX.Element);
};

export const AuthNeededContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return authNeededProviders.reduce((prev, [Provider, key]) => {
    return <Provider key={key}>{prev}</Provider>;
  }, children as JSX.Element) as JSX.Element;
};

export const ContextProvider: React.FC = ({ children }) => {
  return (
    <NoAuthNeededContextProvider>
      <AuthNeededContextProvider>{children}</AuthNeededContextProvider>
    </NoAuthNeededContextProvider>
  );
};
